import React, { useState, useEffect } from "react";
import database from "../config/firebaseConfig";
import firebase from "firebase/compat/app";
import "./styles/Checkout.css";
import CheckoutCard from "../components/CheckoutCard";
import WebsiteFooter from "../components/WebsiteFooter";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

const CheckoutPage = ({ cart, loggedInUser, products }) => {
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [contactEmail, setContactEmail] = useState("");
    const [formErrors, setFormErrors] = useState("");
    const [deliveryDetails, setDeliveryDetails] = useState({
        country: "India",
        fullName: "",
        address: "",
        apartment: "",
        city: "",
        state: "Maharashtra",
        pin: "",
        phone: "",
    });
    const [cities, setCities] = useState([]);  // To hold city names dynamically fetched from Firebase
    const [pinCodes, setPinCodes] = useState({
        Mumbai: [],
        Navimumbai: [],
    });
    const [netValues, setNetValues] = useState({ Weight: 0, Amount: 0 });
    const [taxBreakdown, setTaxBreakdown] = useState({
        cgst: 0,
        sgst: 0,
        total: 0,
    });

    // const [estimatedDeliveryDays, setEstimatedDeliveryDays] = useState("N/A");
    // const [estimatedETD, setEstimatedETD] = useState("N/A");
    const [paymentType, setPaymentType] = useState(0); // Default is prepaid
    const [totalAmount, setTotalAmount] = useState({})
    const [token, setToken] = useState(null);
    const navigate = useNavigate();

    const prepaidValue = 50;
    const codValue = 120;

    const shippingCharge = netValues.Amount >= 499 ? 0 : (paymentType === 0 ? prepaidValue : codValue);

    useEffect(() => {
        // Check if netValues.Amount is valid and if the breakdown needs to be recalculated
        if (netValues?.Amount != null) {
            const calculateTaxBreakdown = (amount) => {
                const taxRate = 0.06; // 6% for CGST and SGST
                const basePrice = amount; // Base price is the amount (₹80)
                const gstAmount = basePrice * taxRate; // CGST and SGST are the same

                const cgst = gstAmount.toFixed(2);
                const sgst = gstAmount.toFixed(2);
                const totalWithGST = (basePrice + gstAmount * 2).toFixed(2); // Total = Base + CGST + SGST

                return {
                    basePrice: basePrice.toFixed(2),
                    cgst: cgst,
                    sgst: sgst,
                    totalWithGST: totalWithGST,
                };
            };

            const newBreakdown = calculateTaxBreakdown(netValues.Amount);

            if (
                newBreakdown.basePrice !== taxBreakdown.basePrice ||
                newBreakdown.cgst !== taxBreakdown.cgst ||
                newBreakdown.sgst !== taxBreakdown.sgst ||
                newBreakdown.totalWithGST !== taxBreakdown.totalWithGST
            ) {
                setTaxBreakdown(newBreakdown);
            }
        }
    }, [netValues?.Amount, taxBreakdown]);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const authResponse = await fetch('https://apiv2.shiprocket.in/v1/external/auth/login', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email: process.env.REACT_APP_SHIPROCKET_EMAIL,
                        password: process.env.REACT_APP_SHIPROCKET_PASSWORD,
                    }),
                });

                if (!authResponse.ok) {
                    const errorData = await authResponse.json();
                    throw new Error(errorData.message || 'Authentication failed!');
                }

                const authData = await authResponse.json();
                setToken(authData.token);

                localStorage.setItem("shiprocketToken", authData.token);

            } catch (error) {
                console.error('Error during Shiprocket authentication:', error);
                alert('Failed to authenticate with Shiprocket. Please check your credentials.');
            }
        };
        fetchToken();
    }, []);

    useEffect(() => {
        const fetchData = () => {
            const cityRef = firebase.database().ref('Maharashtra');

            cityRef.once('value', (snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    setPinCodes({
                        Mumbai: data.Mumbai || [],
                        Navimumbai: data.Navimumbai || [],
                    });
                    setCities(Object.keys(data));
                } else {
                }
            });
        };

        fetchData();
    }, []);

    // useEffect(() => {
    //     const fetchShippingCharges = async () => {
    //         try {
    //             if (!deliveryDetails.pin || !netValues || !netValues.Weight || !token) {
    //                 setShippingCharges(0);
    //                 return;
    //             }

    //             const rateEstimationData = {
    //                 pickup_postcode: "400049",
    //                 delivery_postcode: deliveryDetails.pin,
    //                 weight: netValues.Weight / 1000,
    //                 cod: codValue,
    //                 declared_value: netValues.Amount,
    //                 length: 10,
    //                 breadth: 15,
    //                 height: 20,
    //             };

    //             const queryParams = new URLSearchParams(rateEstimationData).toString();

    //             const rateResponse = await fetch(
    //                 `https://apiv2.shiprocket.in/v1/external/courier/serviceability/?${queryParams}`,
    //                 {
    //                     method: 'GET',
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${token}`,
    //                     },
    //                 }
    //             );

    //             if (!rateResponse.ok) {
    //                 throw new Error('Failed to fetch shipping charges!');
    //             }

    //             const rateData = await rateResponse.json();

    //             if (rateData.status === 200) {
    //                 const surfaceDeliveryCompanies = rateData.data.available_courier_companies?.filter(company => company.mode === 0);

    //                 if (surfaceDeliveryCompanies.length > 0) {
    //                     const cheapestCompany = surfaceDeliveryCompanies.reduce((minCompany, currentCompany) =>
    //                         currentCompany.rate < minCompany.rate ? currentCompany : minCompany
    //                     );
    //                     const shippingCharge = cheapestCompany.rate;
    //                     setShippingCharges(shippingCharge);

    //                     const estimatedDeliveryDays = cheapestCompany.estimated_delivery_days || "N/A";
    //                     const estimatedETD = cheapestCompany.etd || "N/A";

    //                     setEstimatedDeliveryDays(estimatedDeliveryDays);
    //                     setEstimatedETD(estimatedETD);
    //                 } else {
    //                     console.error('No surface delivery options available.');
    //                 }
    //             } else {
    //                 throw new Error('No courier service available for the given details!');
    //             }

    //         } catch (error) {
    //             console.error('Error calculating shipping charges:', error);
    //             alert('Failed to calculate shipping charges. Please try again.');
    //             setShippingCharges(0);
    //         }
    //     };

    //     fetchShippingCharges();
    // }, [deliveryDetails.pin, netValues, netValues.Weight, netValues.Amount, token, codValue]);


    useEffect(() => {
        if (!loggedInUser || !cart || cart.length === 0) {
            return;
        }

        let netValue = { Weight: 0, Amount: 0 };

        cart.forEach(item => {
            netValue.Weight += (item.Weight || 0) * (item.quantity || 1);
            netValue.Amount += (item.Price || 0) * (item.quantity || 1);
        });

        setNetValues(netValue);

        if (taxBreakdown?.totalWithGST) {
            setTotalAmount(parseFloat(taxBreakdown.totalWithGST) + parseFloat(shippingCharge));
        }


    }, [cart, shippingCharge, taxBreakdown, loggedInUser]);

    const validateForm = () => {
        const errors = [];
        if (!contactEmail) errors.push("Email is required.");
        if (!deliveryDetails.fullName) errors.push("Full name is required.");
        if (!deliveryDetails.address) errors.push("Address is required.");
        if (!deliveryDetails.city) errors.push("City is required.");
        if (!deliveryDetails.state) errors.push("State is required.");
        if (!deliveryDetails.pin) errors.push("PIN code is required.");
        if (!deliveryDetails.phone) errors.push("Phone number is required.");

        if (errors.length > 0) {
            setFormErrors(errors.join("\n"));
            return false;
        }
        setFormErrors("");
        return true;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDeliveryDetails({ ...deliveryDetails, [name]: value });

    };

    const saveUserDetails = async () => {
        try {
            const userRef = database.ref(`Customers/${loggedInUser}`);
            await userRef.set({
                email: contactEmail,
                deliveryDetails,
            });
            alert("Details saved successfully!");
        } catch (error) {
            console.error("Error saving user details:", error);
        }
    };

    const calculateItemPriceWithGST = (itemPrice) => {
        const gstRate = 0.06; // 6% CGST and 6% SGST
        const cgst = itemPrice * gstRate; // CGST
        const sgst = itemPrice * gstRate; // SGST
        const totalPriceWithGST = itemPrice + cgst + sgst;
        return totalPriceWithGST.toFixed(2); // Return the price with GST rounded to 2 decimal places
    };


    useEffect(() => {
        if (Array.isArray(cart)) {
            const calTotalAmount = cart.reduce((total, item) => total + (item.Price * item.quantity), 0);
            setAmount(calTotalAmount);
        }
    }, [cart]);

    const updateUserDetails = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            const userRef = database.ref(`Customers/${loggedInUser}`);
            await userRef.update({
                email: contactEmail,
                deliveryDetails,
            });
        } catch (error) {
            console.error("Error updating user details:", error);
        }
    };

    useEffect(() => {
        if (loggedInUser) {
            // Dynamically load Razorpay script if not already included
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.body.appendChild(script);

            const fetchUserDetails = async () => {
                try {
                    const userRef = database.ref(`Customers/${loggedInUser}`);
                    const snapshot = await userRef.once("value");

                    if (snapshot.exists()) {
                        const userData = snapshot.val();
                        setContactEmail(userData.email);
                        setDeliveryDetails((prevDetails) => ({
                            ...prevDetails,
                            ...userData.deliveryDetails,
                        }));
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchUserDetails();
            return () => {
                document.body.removeChild(script);
            };
        } else {
            setLoading(false);
        }
    }, [loggedInUser]);

    if (loading) return <p>Loading...</p>;

    async function createShiprocketOrder(generatedInvoiceNo) {
        try {
            const orderData = {
                order_id: generatedInvoiceNo,
                order_date: new Date().toISOString(),
                pickup_location: "warehouse",
                "channel_id": 5409614,
                "comment": "Fragile",
                billing_customer_name: deliveryDetails.fullName,
                billing_last_name: deliveryDetails.fullName,
                billing_address: deliveryDetails.address,
                billing_address_2: "",
                billing_city: deliveryDetails.city,
                billing_pincode: deliveryDetails.pin,
                billing_state: deliveryDetails.state,
                billing_country: deliveryDetails.country,
                billing_email: contactEmail,
                billing_phone: deliveryDetails.phone,
                "shipping_is_billing": true,
                order_items: cart.map((item) => ({
                    name: item.Name,
                    sku: item.id || `SKU-${item.Name.replace(/\s+/g, '-')}`,
                    units: item.quantity || 1,
                    selling_price: calculateItemPriceWithGST(item.Price),
                    discount: "",
                    tax: "12",
                    hsn: item.hsn || ""
                })),
                payment_method: paymentType === 1 ? "COD" : "Prepaid",
                sub_total: taxBreakdown.totalWithGST,
                // "estimatedDeliveryDays": estimatedDeliveryDays,
                // "estimatedETD": estimatedETD,
                shipping_charges: shippingCharge,
                giftwrap_charges: 0,
                transaction_charges: 0,
                total_discount: 0,
                length: 10,
                breadth: 15,
                height: 20,
                weight: netValues.Weight / 1000,
            }

            await database.ref(`Customers/${loggedInUser}/Orders/${generatedInvoiceNo}/OrderDetails`).update(orderData);

            // Step 3: Create order in Shiprocket
            const orderResponse = await fetch('https://konkanroute-server-954051681713.southamerica-east1.run.app/v1/external/orders/create/adhoc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(orderData),
            });

            if (!orderResponse.ok) {
                throw new Error('Order creation failed!');
            }

            const orderResponseData = await orderResponse.json();

            if (orderResponseData.status_code === 200 || orderResponseData.status_code === 202 || orderResponseData.status_code === 1) {
                await database.ref(`Customers/${loggedInUser}/Orders/${generatedInvoiceNo}/OrderConfirmationDetails`).update(orderResponseData);

                const transactionData = {
                    transaction_id: generatedInvoiceNo,
                    order_id: orderResponseData.order_id,
                    items: cart.map(item => ({
                        name: item.Name,
                        quantity: item.quantity || 1,
                        price: (item.Price),
                    })),
                    subtotal: cart.reduce((sum, item) => sum + (item.Price * (item.quantity || 1)), 0),
                    tax: parseFloat(taxBreakdown.cgst) + parseFloat(taxBreakdown.sgst),
                    shipping: shippingCharge,
                    total: totalAmount,
                    timestamp: new Date()
                };
                console.log(transactionData)
                window.gtag('event', 'Order_Placed_Successfully', transactionData);

                navigate(`/ThankYou/${generatedInvoiceNo}`);
            } else {
                alert('Failed to create order in Shiprocket.');
            }

        } catch (error) {
            console.error('Error with Shiprocket integration:', error);
            alert('Failed to integrate with Shiprocket. Please try again.');
        }
    };

    const handlePayment = async () => {
        if (!validateForm()) {
            return;
        }

        const generatedInvoiceNo = `${Date.now()}`;

        if (paymentType === 0) {
            fetch('https://konkanroute-server-954051681713.southamerica-east1.run.app/create-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser}`
                },
                body: JSON.stringify({
                    amount: totalAmount,
                }),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(order => {
                    const options = {
                        key: process.env.REACT_APP_RAZORPAY_KEY,
                        amount: order.amount,
                        currency: "INR",
                        name: "The Konkan Route",
                        description: `Payment for ${cart.map(item => item.Name).join(', ')}`,
                        image: logo,
                        order_id: order.id,
                        handler: function (response) {
                            fetch('https://konkanroute-server-954051681713.southamerica-east1.run.app/verify-payment', {
                                method: 'POST',
                                body: JSON.stringify({
                                    payment_id: response.razorpay_payment_id,
                                    order_id: response.razorpay_order_id,
                                    razorpay_signature: response.razorpay_signature,
                                    cart,
                                    deliveryDetails,
                                    user_id: loggedInUser,
                                    invoice_no: generatedInvoiceNo,
                                    amount
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${loggedInUser}`
                                },
                            })
                                .then(response => response.json())
                                .then(data => {
                                    if (data.success) {
                                        alert('Payment successful!');
                                        createShiprocketOrder(generatedInvoiceNo);
                                    } else {
                                        alert("Payment verification failed!");
                                    }
                                });
                        },
                        prefill: {
                            name: deliveryDetails.fullName,
                            email: contactEmail,
                            contact: deliveryDetails.phone,
                        },
                        theme: {
                            color: "#23370A",
                        },
                    };

                    const rzp = new window.Razorpay(options);
                    rzp.open();
                })
                .catch(err => {
                    console.error("Error creating order:", err);
                });
        } else {
            createShiprocketOrder(generatedInvoiceNo);
        }
    };

    const handleChange = (e) => {
        setPaymentType(parseInt(e.target.value, 10));
    };

    const handleCityChange = (e) => {
        const selectedCity = e.target.value;
        setDeliveryDetails({
            ...deliveryDetails,
            city: selectedCity,
            pin: "", // Reset pin code when city is changed
        });
    };

    return (
        <>
            <div style={{
                position: "fixed",
                top: "100px",
                left: 0,
                width: "100%",
                backgroundColor: "black",
                color: "white",
                textAlign: "center",
                padding: "10px",
                zIndex: 1000
            }}>
                Free shipping on orders above ₹499
            </div>
            <div className="checkout-container">
                <div className="checkout-left">
                    <h2>Contact</h2>
                    <input
                        type="email"
                        placeholder="Email"
                        value={contactEmail}
                        onChange={(e) => setContactEmail(e.target.value)}
                        required
                    />

                    <h2>Delivery</h2>
                    <select
                        name="country"
                        value={deliveryDetails.country}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="India">India</option>
                    </select>
                    <div className="name-field">
                        <input
                            type="text"
                            placeholder="Full name"
                            name="fullName"
                            value={deliveryDetails.fullName}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <input
                        type="text"
                        placeholder="Address"
                        name="address"
                        value={deliveryDetails.address}
                        onChange={handleInputChange}
                        required
                    />
                    <input
                        type="text"
                        placeholder="Apartment, suite, etc. (optional)"
                        name="apartment"
                        value={deliveryDetails.apartment}
                        onChange={handleInputChange}
                        required
                    />
                    <div className="location-fields">
                        <select
                            name="city"
                            value={deliveryDetails.city}
                            onChange={handleCityChange}
                            required
                        >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                                <option key={city} value={city}>
                                    {city}
                                </option>
                            ))}
                        </select>
                        <input
                            type="text"
                            placeholder="State"
                            name="state"
                            value={deliveryDetails.state}
                            onChange={handleInputChange}
                            required
                        />
                        <select
                            name="pin"
                            value={deliveryDetails.pin}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Pin Code</option>
                            {(deliveryDetails.city === "Mumbai"
                                ? pinCodes.Mumbai
                                : deliveryDetails.city === "Navimumbai"
                                    ? pinCodes.Navimumbai
                                    : []
                            ).map((pincode) => (
                                <option key={pincode} value={pincode}>
                                    {pincode}
                                </option>
                            ))}
                        </select>
                    </div>
                    <input
                        type="text"
                        placeholder="Phone"
                        name="phone"
                        value={deliveryDetails.phone}
                        onChange={handleInputChange}
                        required
                    />

                    <div className="payment-summary">
                        <h3>Payment Method:</h3>
                        {paymentType === 1 && (
                            <p style={{ color: "red" }}>
                                Prepaid orders get ₹70 off on shipping!
                            </p>
                        )
                        }
                        <div className={`payment-card ${paymentType === 1 ? "selected" : ""}`}
                            onClick={() => setPaymentType(1)}>
                            <label>
                                <input
                                    type="radio"
                                    name="cod"
                                    value={1}
                                    checked={paymentType === 1}
                                    onChange={handleChange}
                                    required
                                />
                                <span>COD (Cash on Delivery) </span>
                            </label>
                        </div>
                        <div
                            className={`payment-card ${paymentType === 0 ? "selected" : ""}`}
                            onClick={() => setPaymentType(0)}
                        >
                            <label>
                                <input
                                    type="radio"
                                    name="cod"
                                    value={0}
                                    checked={paymentType === 0}
                                    onChange={handleChange}
                                    required
                                />
                                <span>Online Payment</span>
                            </label>
                        </div>
                        <div className="payment-summary">
                            <h3>Selected Value: {paymentType === 1 ? "COD" : "Online Payment"}</h3>
                        </div>
                    </div>

                    {formErrors && <p className="error-message">{formErrors}</p>}

                    <div className="Update">
                        {loggedInUser ? (
                            <button onClick={updateUserDetails}>Update Details</button>
                        ) : (
                            <button onClick={saveUserDetails}>Save Details</button>
                        )}
                    </div>
                </div>

                <div className="checkout-right">
                    <h2>Order Summary</h2>
                    {Array.isArray(cart) && cart.length === 0 ? (
                        <p>Your cart is empty.</p>
                    ) : (
                        <div className="cart-container">
                            {Array.isArray(cart) && cart.map((item, index) => (
                                <div key={index}>
                                    <CheckoutCard key={index + "card"} index={index} item={item} products={products} />
                                    <hr key={index + "hr"} />
                                </div>
                            ))}
                        </div>
                    )}
                    <span className="checkout-totels">
                        <div>Total Weight: <strong> {netValues && netValues.Weight / 1000} Kg</strong></div>

                        <div>Price: <strong>Rs. {taxBreakdown.basePrice}</strong></div>
                        <div>CGST (6%): <strong>Rs. {taxBreakdown.cgst}</strong></div>
                        <div>SGST (6%): <strong>Rs. {taxBreakdown.sgst}</strong></div>

                        <div>Shipping Charges: <strong>Rs.{shippingCharge}</strong></div>
                        <div>Total: <strong>Rs. {totalAmount}</strong></div>
                        {/* Free Shipping Message in Red if Shipping Charge is 0 */}
                        {shippingCharge === 0 && (
                            <div style={{ color: "red", marginTop: "5px" }}>
                                You got free shipping!
                            </div>
                        )}
                    </span>
                    <br />

                    <div className="Payment-Container">
                        <button className="payment" onClick={handlePayment}> Proceed To Buy </button>
                    </div>
                </div>
            </div >
            <WebsiteFooter />
        </>
    );
};

export default CheckoutPage;
